import { CSSResultGroup, html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { ifDefined } from 'lit/directives/if-defined.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { style } from './breadcrumbs.style.js'
import { t } from '@cloudsuite/mosaic-shared/translations/translator.js'
import { initializeIconsByRole } from '@cloudsuite/mosaic-shared/icons/library.js'

initializeIconsByRole({
  'csc-breadcrumbs.back': { name: 'angle-right', style: 'light' }
})

type Breadcrumb = {
  name: string,
  variant: string,
  url: string
}

@customElement('csc-breadcrumbs')
export class CSCBreadcrumbs extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  @property({ type: Array })
  breadcrumbs: Array<Breadcrumb> = []

  @property({ type: Boolean, attribute: 'display-home-text' })
  displayHomeText: boolean = false

  getMobileBreadcrumbURL = () => {
    return this.breadcrumbs.length > 1 ? this.breadcrumbs.slice(-2)[0]?.url : '/'
  }

  renderMobile = () => html`
    <div class="breadcrumbs-mobile">
      <cse-link
        font-variant="body-s"
        url="${ifDefined(this.getMobileBreadcrumbURL())}"
      >
        <cse-icon slot="prefix" icon-role="csc-breadcrumbs.back"></cse-icon>
        ${t('breadcrumbs_back_text_mobile', { ns: 'csc-breadcrumbs', default: 'Back' })}
      </cse-link>
    </div>
  `

  renderDesktop = () => html`
    <cse-group alignment="center" column-gap="none" class="breadcrumbs-desktop">
      ${this.displayHomeText 
        ? html`<cse-breadcrumb-item variant="home" url="/">
            ${t('breadcrumbs_home_text_desktop', { ns: 'csc-breadcrumbs', default: 'Home' })}
          </cse-breadcrumb-item>`
        : html`<cse-breadcrumb-item variant="home" url="/"></cse-breadcrumb-item>`
      }
      ${this.breadcrumbs.map(this.renderBreadcrumb)}
    </cse-group>
  `

  isBreadcrumbCurrent = (index: number) => {
    return this.breadcrumbs.length - 1 === index ? 'current' : 'default'
  }

  renderBreadcrumb = (breadcrumb: Breadcrumb, index: number) => html`
    <cse-breadcrumb-divider></cse-breadcrumb-divider>
    <cse-breadcrumb-item
      variant="${this.isBreadcrumbCurrent(index)}"
      url="${breadcrumb.url}"
    >
      ${breadcrumb.name}
    </cse-breadcrumb-item>
  `

  override render() {
    return html`
      <div class="csc-breadcrumbs">
        ${this.renderDesktop()}
        ${this.renderMobile()}
      </div>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'csc-breadcrumbs': CSCBreadcrumbs,
  }
}
